import { FC } from 'react';
import { TransferReservationType } from '../../viajeTraslado/models/TransferReservationPartial';
import { ViajeTrasladoTipoServicio } from 'app/viaje/models';
interface ParticularClientProps {
  client: {
    name: string;
    companyName: string;
    type: TransferReservationType;
    service: ViajeTrasladoTipoServicio;
  }
  isMobileOrTablet: boolean;
}
const ParticularClient: FC<ParticularClientProps> = ({
  client,
  isMobileOrTablet
}) => {
  const isBusesService =
  client.service === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES;
  return (
    <div className="flex flex-col gap-2 relative">
      <div className="flex justify-between text-sm items-center">
        {isMobileOrTablet ? <p>Cliente</p> : null}
        <div className="flex flex-col gap-2">
          {client.type ===
            TransferReservationType.PARTICULAR_CORPORATIVE && (
            <p
              className="text-start"
              style={{
                color: '#0270AB',
                textShadow: '1px 1px 1px #61FFD0',
                border: '1px solid #61FFD0',
                width: 'fit-content',
                padding: '0px 4px',
                borderRadius: '4px',
                fontSize: '10.5px'
              }}
            >
              {client.companyName}
            </p>
          )}
          <p
            className={`w-28 text-sm ${
              isBusesService ? 'text-purple-600' : 'text-black'
            }`}
          >
            {client.name}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ParticularClient;
